export default __webpack_public_path__ + "static/media/health_check_Hk.6a703f44.webp";